export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12120.2037c372.jpg";